import Vue from 'vue';
import Router from 'vue-router';
import { authModule } from '@/auth/modules';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('@/home/Home.vue'),
        },
        {
            path: '/callback',
            name: 'callback',
            component: () => import('@/auth/components/Callback.component.vue'),
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.name === 'callback') {
        next();
        return;
    }
    if (to.name === 'home') {
        next();
        return;
    }
    if (authModule.isAuthenticated) {
        next();
        return;
    }

    if (!authModule.isAuthenticated) {
        authModule.logIn(to.fullPath);
    }

    // tslint:disable-next-line: no-console
    console.warn('unhandled redirect');
});

export default router;
